import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  publishedTime?: string;
  modifiedTime?: string;
  author?: string;
  section?: string;
  canonical?: string;
  noindex?: boolean;
}

export const SEOHead = ({
  title = "Loris Scandurra - AI Consulting & Digitalization Expert",
  description = "Experte für Azure-Lösungen und KI-Technologien. Transformieren Sie Ihre Geschäftsprozesse mit innovativen Digitalisierungsstrategien und modernen Cloud-Lösungen.",
  keywords = "AI Consulting, Azure, Digitalisierung, Cloud Computing, KI-Lösungen, Business Transformation, Loris Scandurra",
  image = "/lovable-uploads/3ae934ce-d95d-4c69-94c6-89480c0be60b.png",
  url = "https://lorisscandurra.com",
  type = 'website',
  publishedTime,
  modifiedTime,
  author = "Loris Scandurra",
  section,
  canonical,
  noindex = false
}: SEOHeadProps) => {
  const fullTitle = title.toLowerCase().includes('lorisscandurra') || title.toLowerCase().includes('loris scandurra') ? title : `${title} | lorisscandurra`;
  const imageUrl = image.startsWith('http') ? image : `https://lorisscandurra.com${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <meta name="language" content="de" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical || url} />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="de_CH" />
      <meta property="og:site_name" content="Loris Scandurra" />
      
      {/* Article specific tags */}
      {type === 'article' && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {type === 'article' && modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}
      {type === 'article' && author && (
        <meta property="article:author" content={author} />
      )}
      {type === 'article' && section && (
        <meta property="article:section" content={section} />
      )}
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@lorisscandurra" />
      <meta name="twitter:creator" content="@lorisscandurra" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      
      {/* Additional SEO Tags */}
      
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="theme-color" content="#1e40af" />
    </Helmet>
  );
};